/* istanbul ignore file */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
/**
 * This hook is used in functional components.
 * Use it whenever you must render only when the hydration phase is complete (i.e. first lifecycle has been invoked)
 */ export function useHydration() {
    const [isHydrated, setIsHydrated] = useState(false);
    useEffect(()=>{
        setIsHydrated(true);
    }, []);
    return isHydrated;
}
/**
 * Used for legacy class components. Please avoid using this and use the hook {@link useHydration} instead inside a functional component.
 */ export function withHydration(WrappedComponent) {
    return function ComponentWithHydration(props) {
        const isHydrated = useHydration();
        return /*#__PURE__*/ _jsx(WrappedComponent, _object_spread_props(_object_spread({}, props), {
            isHydrated: isHydrated
        }));
    };
}
